import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormHelper } from '@app/shared/helpers/form';
import { IDropdown } from '@app/shared/interfaces/dropdown';
import { USER_ROLE } from '@app/modules/user/consts/role';

@Component({
  selector: 'app-select-role-form',
  templateUrl: './select-role-form.component.html',
})
export class SelectRoleFormComponent {

  public visible = true;

  @Input() public placeholder;

  @Input() public set selectedRole(role: USER_ROLE) {
    this._role = role;
    this.createForm(role);
  }

  @Input() public roles: IDropdown<USER_ROLE>[];

  @Output() public submitEvent = new EventEmitter<USER_ROLE>();

  public form: FormGroup;

  public get role(): FormControl {
    return this.form.get('role') as FormControl;
  }

  private _role: USER_ROLE;

  /**
   * @param fb
   * @param cdf
   */
  constructor(
    private readonly fb: FormBuilder,
    private readonly cdf: ChangeDetectorRef
  ) {}

  public submit(): void {
    FormHelper.markAllAsDirty(this.form);

    if (this.form.valid || this._role) {
      this.submitEvent.emit(this.role.value);
    }
  }

  public getErrorMessage(key: string, control: FormControl): string {
    return FormHelper.getErrorMessage(key, control);
  }

  private createForm(role: USER_ROLE): void {
    this.form = this.fb.group({
      role: [{ value: role, disabled: !!role }, [Validators.required]],
    });

    // for dynamic update svg icon in selectedItem
    this.role.valueChanges.subscribe(() => {
      this.visible = false;
      this.cdf.detectChanges();

      this.visible = true;
      this.cdf.detectChanges();
    });
  }
}
